import { render, staticRenderFns } from "./ScorePoint.vue?vue&type=template&id=61fb938c&scoped=true"
import script from "./ScorePoint.vue?vue&type=script&lang=js"
export * from "./ScorePoint.vue?vue&type=script&lang=js"
import style0 from "./ScorePoint.vue?vue&type=style&index=0&id=61fb938c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb938c",
  null
  
)

export default component.exports